export default __webpack_public_path__ + "static/media/img_moutains-min.0b9eb4bc.jpg";